import client from '../../client'
import { ApiResponse, PagerMeta } from '../../types'
import { ActivityWithProgramCount } from '../activities'
import { CampaignBanner } from '../campaignBanners'
import {
  CampaignFacility,
  Facility,
  RecommendedFacility,
  SearchMetadata,
} from '../facilities'
import { Notification } from '../notifications'
import { ListActivityRankingsResponse } from '../rankings/types'

export const fetchAll = async () => {
  const {
    data,
    meta,
  }: ApiResponse<
    {
      notifications: Notification[]
      campaignFacilities: CampaignFacility[]
      recommendedFacilities: RecommendedFacility[]
      onlineFacilities: Facility[]
      campaignBanners: CampaignBanner[]
      activities: ActivityWithProgramCount[]
      activityRankings: ListActivityRankingsResponse
      facilityMetadata: SearchMetadata
    },
    PagerMeta
  > = await client.get(`/user/top`, { headers: { 'Cache-Control': 'public' } })
  return { data, meta }
}
